import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询老师课堂评价统计 post
  classEvaluationGetTeacherStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASS_EVALUATION_GET_TEACHER_STAT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 管理员-校区+年级统计
  getCampusGradeStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_GRADE_STA, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级详情(科目 & 学生平均分)
  getClassDetails(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_CLASS_DETAILS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取课程学生平均分详情
  getCourseDetails(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_COURSE_DETAILS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 管理员-年级+班级统计
  getGradeClassStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_CLASS_STA, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师- 我的评价详情
  getMyEvaluationDetails(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_DETAILS_TEACHER, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师- 我的评价列表
  getMyEvaluationList(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CLASS_EVALUATION_LIST_TEACHER, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 老师- 我的评价批量提交
  myEvaluationBatchSave(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASS_EVALUATION_SAVE_BEATCH, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取存在老师的课程
  getExitTeacherCourses(postData) {
    return http.post(URL.API_CLASS_EVALUATION_TEACHER_COURSE_LIST, postData)
  },
  // 课堂评价导出统计报表（通过工作通知发送给操作人员）
  exportCourseEvaluation(postData) {
    return http.post(URL.API_COURSE_EVALUATION_EXPORT, postData)
  },
  getAuditMemberConfig: postData =>
    http.get(URL.API_CLASSRANK_GET_AUDIT_MEMBER_CONFIG, postData),
  saveAuditMemberConfig: postData =>
    http.post(URL.API_CLASSRANK_SAVE_AUDIT_MEMBER_CONFIG, postData),
  getDetailShowInClassPadConfig: postData =>
    http.get(URL.API_CLASSRANK_GET_AUDIT_SHOW_CONFIG, postData),
  saveDetailShowInClassPadConfig: postData =>
    http.post(URL.API_CLASSRANK_SAVE_AUDIT_SHOW_CONFIG, postData),
  getClassrankAuditPageList: postData =>
    http.post(URL.API_CLASSRANK_GET_AUDIT_LIST, postData),
  batchUpdateAuditStatus: postData =>
    http.post(URL.API_CLASSRANK_SAVE_AUDIT, postData)
}
